import _toConsumableArray from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
/* eslint-disable react/forbid-prop-types */
import Snackbar from '@molecules/Snackbar';
import { useTranslation } from 'config/i18n';
import { ERRORS_CATEGORIES } from 'constants/errors';
import React from 'react';
var MutationsStatus = function MutationsStatus(_ref) {
  var loading = _ref.loading,
    error = _ref.error,
    success = _ref.success,
    errorMessage = _ref.errorMessage;
  var _useTranslation = useTranslation(['common']),
    t = _useTranslation.t;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    open = _React$useState2[0],
    setOpen = _React$useState2[1];
  var type = 'loading';
  if (error) {
    type = 'error';
  }
  if (success) {
    type = 'success';
  }
  var handleClose = function handleClose() {
    setOpen(false);
  };
  React.useEffect(function () {
    if (loading || error || success) {
      setOpen(true);
    }
  }, [loading, error, success]);
  var getMessage = function getMessage(snackType) {
    var message = [];
    if (snackType === 'loading') {
      message = [/*#__PURE__*/React.createElement('div', {
        key: 'loading'
      }, t('loading'))];
    }
    if (snackType === 'success') {
      message = [/*#__PURE__*/React.createElement('div', {
        key: 'success'
      }, t('success'))];
    }
    if (type === 'error') {
      var _ref2 = error || {},
        _ref2$graphQLErrors = _ref2.graphQLErrors,
        graphQLErrors = _ref2$graphQLErrors === void 0 ? null : _ref2$graphQLErrors,
        _ref2$message = _ref2.message,
        graphMessage = _ref2$message === void 0 ? null : _ref2$message;
      message = [/*#__PURE__*/React.createElement('div', {
        key: 'errorMessage'
      }, errorMessage || t('sorry.error'))];
      if (graphQLErrors && graphQLErrors.length > 0) {
        var _loop = function _loop(i) {
          switch (graphQLErrors[i].extensions.category) {
            case ERRORS_CATEGORIES.VALIDATION:
              {
                message = [/*#__PURE__*/React.createElement('div', {
                  key: "validation-".concat(i)
                }, Object.values(graphQLErrors[i].extensions.validation).reduce(function (acc, val) {
                  return [].concat(_toConsumableArray(acc), _toConsumableArray(val));
                }, []).map(function (msg) {
                  return /*#__PURE__*/React.createElement('div', {
                    key: "validation-".concat(i, "-").concat(msg)
                  }, /*#__PURE__*/React.createElement(React.Fragment, null, msg, /*#__PURE__*/React.createElement('br')));
                }))];
                break;
              }
            case ERRORS_CATEGORIES.AUTHENTICATION:
              message = [/*#__PURE__*/React.createElement('div', {
                key: "error-".concat(i)
              }, graphMessage)];
              break;
            case ERRORS_CATEGORIES.BAD_REQUEST:
              message = [/*#__PURE__*/React.createElement('div', {
                key: "error-".concat(i)
              }, graphMessage)];
              break;
            default:
              message = [/*#__PURE__*/React.createElement('div', {
                key: "default-error-".concat(i)
              }, t('sorry.error'))];
              break;
          }
        };
        for (var i = 0; i < graphQLErrors.length; i += 1) {
          _loop(i);
        }
      }
    }
    return /*#__PURE__*/React.createElement('div', null, message);
  };
  return /*#__PURE__*/React.createElement(Snackbar, {
    type: type,
    open: open,
    message: getMessage(type),
    close: type !== 'loading',
    autoHideDuration: 3000,
    onClose: handleClose
  });
};
MutationsStatus.defaultProps = {
  loading: undefined,
  error: undefined,
  success: undefined,
  errorMessage: null
};
export default MutationsStatus;